import React from 'react';
import './css/CorporateResponsibility.css';
// import headerBg from './assets/picOne.png'; // Use a relevant header 
import headerBg from './assets/books.jpeg';

const Responsibility = () => {
    return (
        <div className="header-responsibility">
            {/* === Overlay Header === */}
            <section
                className="responsibility-header"
                style={{
                    backgroundImage: `url(${headerBg})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '40vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <div className="overlay">
                    <h1 className="page-title">Catalogue of Malawi Standards</h1>
                    {/* <p className="subtitle">
                        Access the Malawi Bureau of Standards (MBS) Strategic Plan to understand our goals, priorities, and roadmap for promoting quality, standards, and compliance in Malawi.
                    </p> */}
                </div>
            </section>

            {/* === PDF Viewer Section === */}
            <section className="strategic-plan-section" style={{ marginTop: '40px' }}>
                <center>
                    <iframe
                        src="http://192.168.0.5:3600/api/catalogue-of-malawi-standards"
                        title="MBS Strategic Plan"
                        width="80%"
                        height="600px"
                        style={{
                            border: '1px solid #ccc',
                            borderRadius: '8px',
                            boxShadow: '0 0 10px rgba(0,0,0,0.1)',
                        }}
                    />
                </center>
            </section>

            {/* === Inline Styles for Overlay === */}
            <style>{`
            .responsibility-header .overlay {
    background: rgba(0, 0, 0, 0.5);
    padding: 2rem;
    border-radius: 1rem;
    border-right: 4px solid #ff6600;
    border-left: 4px solid #ff6600;
    width: 90%;
}
         
                .overlay {
                    background: rgba(0,0,0,0.55);
                    padding: 40px;
                    text-align: center;
                    color: white;
                    width: 90%;
                    max-width: 1200px;
                    border-radius: 12px;
                }
                .page-title {
                    font-size: 2.2rem;
                    font-weight: bold;
                    margin-bottom: 10px;
                }
                .subtitle {
                    font-size: 1rem;
                    margin-top: 5px;
                    font-weight: 500;
                }
            `}</style>
        </div>
    );
};

export default Responsibility;
